// removed by extract-text-webpack-plugin
module.exports = {"popover":"_1PJaB","title":"_3oZM_","option":"_3sT2c _1a-AI","valueLabel":"UY_RI","on":"_1YWy_","selected":"BoMv1"};


//////////////////
// WEBPACK FOOTER
// ./dashboard/components/RefreshWidget.css
// module id = 1531
// module chunks = 0 3 5